<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList" v-show="pages.trial && currentPage === pages.trial.name">
      <div class="topLeft">
        <h3>L0订单<span class="time">实时更新</span></h3>
        <div class="refresh">手动刷新页面，拉取实时体验课订单数据</div>
      </div>
      <div class="topRight">
        <div>管理员能看到所有成员的订单<br />普通成员只能看到自己的和无归属人的订单<br/>后台数据包含退费订单，实际数据需与对接人确认</div>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="支付状态">
          <el-select v-model="listQuery.order_status" placeholder="请选择支付状态">
            <el-option
              v-for="item in allOrderStatu"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="payWay">
          <el-select v-model="listQuery.payType" placeholder="请选择支付时间">
            <el-option
              v-for="item in allTime"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="createTime"
            value-format="timestamp"
            type="daterange"
            :picker-options="pickerOptions"
            @blur="enableChoose"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="归属人">
          <el-select v-model="listQuery.member_id" filterable placeholder="请选择归属人">
            <el-option label="全部归属人" :value="null" />
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.agentCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input v-model="listQuery.promotion_link_id" placeholder="输入推广链接ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="listQuery.order_no" placeholder="输入订单号查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            type="number"
            v-model="listQuery.phone"
            placeholder="输入手机号查询"
            class="orderStyle numrule"
            maxlength="11"
            autocomplete="on"
            @input="checkLength"
            @keyup.native="checkPhoneNumber"
          />
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <!-- 下载组建 -->
        <DownExcel
          :listQuery="listQuery"
          :createTime="createTime"
          :total="total"
          pageType="trial"
        />
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="下单时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.order_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.pay_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像" align="center" width="80">
          <template slot-scope="{row}">
            <img :src="row.wx_avater || '//wxlogo.hetao101.com/default_avatar.png'" alt="avatar" class="avatar" />
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.wx_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.user_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ handleStatus(row.order_status) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否重复购买" align="center" min-width="115"  v-if="repeatBuy">
          <template slot-scope="{row}">
            <span>{{ (row.is_repeat_buy ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="课程科目" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.subject_type || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{ row.order_no || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{  row.order_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="归属人" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.member_name || '无归属人' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_link_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广渠道" width="180px">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="row.promotion_channel_name" placement="top">
              <span>{{ row.promotion_channel_name && row.promotion_channel_name.length > 10 ? `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name || '--' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="推广位" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_position_id }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.index"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <div class="distributorList" v-show="pages.importOrder && currentPage === pages.importOrder.name" >
      <ImportOrder></ImportOrder>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { mapGetters } from 'vuex'
import Pagination from "@/components/Pagination/index";
import DownExcel from "@/components/DownExcel/index";
import ImportOrder from "./ImportOrder.vue"
import { getTermListNew } from "@/services/term";
import { getOrderList, getStatistics, getCourseList } from "@/services/order";
import { getChannelList, getTeamList } from "@/services/link";
import { getPromotionList } from "@/services/promotion";
import PowerWrapper from "@/components/PowerWrapper";
import { timestampToDate, delUndefined, numFormat, timestampToDateTotal } from "@/utils/utils";
import { getAgentCode, getTeamCode, getTeamRole } from '@/utils/auth'

export default {
  name: "order",
  components: {
    Pagination,
    PowerWrapper,
    DownExcel,
    ImportOrder,
  },
  data() {
    return {
      CurrRole: "order",
      list: [],
      termList: [], // 学期array
      currentPage: 'trial',
      pages: {
        trial: {
          name: 'trial',
          text: '体验课订单'
        }
      },
      gradeList: {
        1: '一年级',
        2: '二年级',
        3: '三年级',
        4: '四年级',
        5: '五年级',
        6: '六年级',
        11: '初一',
        12: '初二',
        13: '初三',
      },
      emptyText: '暂无数据',
      listQuery: {
        course_type: 'QUARTER',
        index: 1,
        pageSize: 10,
        subject_type: '',
        class_open_time: '',
        orderStatus: null,
        renew: null,
        payType: 'payTime',
        courseId: null,
        channelCode: null,
        positionCode: null,
        belongerCode: (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) ? null : getAgentCode(),
        wxName: null,
        orderNumber: null,
        linkCode: null,
        is_repeat_buy: '',
        term_id: null,
        studyProgress: null,
        mobile: null,
        grade: [],
        user_id: null,
        pay_amount: null,
        promotion_course_id: [],
      },
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        // disabledDate: time => {
        //   if (this.pickerMinDate) {
        //     const day1 = 93 * 24 * 3600 * 1000;
        //     const maxTime = this.pickerMinDate + day1;
        //     const minTime = this.pickerMinDate - day1;
        //     return time.getTime() > maxTime || time.getTime() < minTime;
        //   }
        // }
      },
      total: 1,
      allOrderStatu: [
        {
          value: null,
          name: '全部支付状态'
        },
        {
          value: 'PAID',
          name: '已支付'
        },
        {
          value: 'UNPAID',
          name: '未支付'
        },
        {
          value: 'REFUND',
          name: '已退费'
        }
      ],
      allTime: [
        {
          value: 'payTime',
          name: '支付时间'
        },
        {
          value: 'orderTime',
          name: '下单时间'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      courseList: [],
      channelList: [],
      promotionList: [],
      teamList: [],
      updateTime: null
    };
  },
  computed: {
    ...mapGetters([
      'renewShow',
      'repeatBuy',
      'manualOrder'
    ]),
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getList()
    // 统计接口
    this.getStatistics()
    // 获取推广课程
    this.getCourseList()
    // 获取推广渠道
    this.getChannelList()
    // 获取团队成员信息
    this.getTeamList()
    // 获取学期列表
    this.getTermList()
  },
  watch: {
    manualOrder: {
      handler(val) {
        this.setTab(val);
      }
    }
  },
  mounted() {
    this.setTab(this.manualOrder);
  },
  methods: {
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type;
    },
    setTab(isManualOrder) {
      if (isManualOrder) {
        const importOrder = {
          name: 'importOrder',
          text: '手动导入订单'
        }
        Object.assign(this.pages, { importOrder });
      }
    },
    checkLength (e) {
      if (e.length > 11) {
        this.listQuery.mobile = e.slice(0, 11)
      }
    },
    checkPhoneNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.mobile = this.listQuery.mobile && regNum.test(this.listQuery.mobile) ? this.listQuery.mobile.toString().replace(/[^\d]/g, '') : this.listQuery.mobile;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    getTermList() {
      getTermListNew().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else {
          this.termList = [];
        }
      });
    },
    getStatistics() {
      this.updateTime = Date.parse(new Date());
      const params = {
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      getStatistics(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const orderList = res.data.data;
          if (orderList && orderList.length > 0) {
            this.statisticsArr = orderList.map(element => {
              if (element && element.timeType) {
                return {
                  label: element.timeType === 'today' ? '今日订单量'
                    : element.timeType === 'week' ? '本周订单量'
                      : element.timeType === 'month' ? '本月订单量'
                        : element.timeType === 'total' ? '累计订单总量' : '',
                  number: element.number || 0,
                  show: element.timeType === 'today'
                }
              }
            });
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.statisticsArr = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (query === 'all') {
          delete _listQuery[key]
        } else if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const { payType, grade, term_id, promotion_course_id } = _listQuery;
      const params = {
        orderType: 'desc',
        orderColumn: 'order_time',
        ..._listQuery,
        index: btnName === 'search' ? 1 : this.listQuery.index,
        grade: grade && grade.join(','),
        promotion_course_id: Array.isArray(promotion_course_id) ? promotion_course_id.join(',') : null,
        term_id: Array.isArray(term_id) ? term_id.join(',') : null,
        start_pay_time: payType === 'payTime' && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_pay_time: payType === 'payTime' && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        start_order_time: payType === 'orderTime' && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_order_time: payType === 'orderTime' && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      delete params.payType;
      getOrderList({
        type: 'POST',
        params: {
          ...delUndefined(params)
        }
      }).then((res = {}) => {
        const { errCode, errMsg, data, total } = res.data || {};
        if (errCode === 0 && Array.isArray(data) && data.length > 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.emptyText = errMsg && errMsg !== 'success' ? errMsg : '暂无数据';
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    getPromotionList(channelCode) {
      const params = {
        teamCode: getTeamCode(),
        channelCode: channelCode
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.promotionList = [];
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode()
      }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: '我的'
              },
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    handleChannel(value) {
      this.channelCode = value;
      this.listQuery.positionCode = null;
      if (value) {
        this.getPromotionList(value)
      } else {
        this.promotionList = [];
      }
    },
    handleSearch() {
      this.getList('search');
    },
    checkUserIdLength (e) {
      if (e.length > 13) {
        this.listQuery.user_id = e.slice(0, 13)
      }
    },
    checkUserIdNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.user_id = this.listQuery.user_id && regNum.test(this.listQuery.user_id) ? this.listQuery.user_id.toString().replace(/[^\d]/g, '') : this.listQuery.user_id;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.icon-question{
  cursor: pointer;
}
</style>
